export const REAL_ASSET_INFO_TYPE_COUNT = "realAssetCount";
export const REAL_ASSET_INFO_TYPE_FORM = "realAssetInfoForm";
